export const copyToClipboard = (str: string) => {
  return new Promise((resolve, reject) => {
    navigator.clipboard.writeText(str).then(resolve, reject);
  });
};

export const copyToClipboardIFrame = async (str: string) => {
  const iframe = `<iframe src='${str}' height='600' width='800' allowfullscreen></iframe>`;
  return copyToClipboard(iframe);
};
